module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/pescetarian@3x__432eeecf9f62a37f6dde961b03014904.png";